import type { WritableSignal, InputSignal, OnInit } from '@angular/core';
import { Component, signal, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import { LtIconComponent } from '@app/components/core/lt-icon/lt-icon.component';
import { LtTranslatePipe } from '@app/pipes/lt-translate.pipe';
import type { IYearbookInfoService } from '@app/interface/yearbook/yearbook-info-service.interface';

@Component({
  selector: 'lt-yearbook-banner',
  imports: [CommonModule, LtTranslatePipe, LtIconComponent],
  templateUrl: './yearbook-banner.component.html',
  styleUrl: './yearbook-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YearbookBannerComponent implements OnInit {
  lifetouchId: InputSignal<string> = input.required();

  yearbookInfoService: IYearbookInfoService = inject<IYearbookInfoService>(angularjs.YearbookInfoService);

  public yearbookHref: WritableSignal<string | null> = signal(null);

  ngOnInit(): void {
    void this.yearbookInfoService.getYearbookHref(this.lifetouchId()).then((href) => this.yearbookHref.set(href));
  }
}

App.directive(
  'ltYearbookBanner',
  downgradeComponent({
    component: YearbookBannerComponent
  })
);
